import { render, staticRenderFns } from "./PregnantAminoAcid.vue?vue&type=template&id=6f33f5c4"
import script from "./PregnantAminoAcid.vue?vue&type=script&lang=js"
export * from "./PregnantAminoAcid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports